var cache = null

export default function(o, done){

  var server = o.util.getUrl('frontend')

  var lang = o.store('lang')

  if(cache){
    requestAnimationFrame(function(){
      done(cache)
    })
  } else {
    $.ajax({
      url: `${server}?type=aaTags`,
      type: "GET",
      cache: false,
      headers: { "cache-control": "no-cache" },
    })
    .done(function(data, textStatus, jqXHR) {
      cache = _.sortBy(data, function(tag){return tag[lang].toLowerCase()})
      done(cache)
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error('error loading aaTags data')
      done()
    })
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/data/aaTags/aaTags.js